import React from 'react';
import  './SpecialIn.css'
import { FaLaptopCode } from "@react-icons/all-files/fa/FaLaptopCode";
import { FaReact } from "@react-icons/all-files/fa/FaReact";
import { FaTv } from "@react-icons/all-files/fa/FaTv";
import { FaMicrophone } from "@react-icons/all-files/fa/FaMicrophone";

const SpecialIn = () => {
    return (
        <div className="container quality-section mb-3 me-3 ms-3">
            <div className="container">
            <div>
            <h4 className="quality-header">What I Do</h4>
            <hr style={{width: '9%',height: '2px', color:'blue'}}/>
            </div>
            <div className="qualities">
                <div className="row mt-4 p-2">
                    <div className="col-md-2">
                    <FaLaptopCode className="icons"/>
                    </div>
                    <div className="col-md-9 p-2">
                        <h5>Web Development</h5>
                        <p>I am an enthusiastic web developer having knowledge of HTML,CSS,JavaScript.I know various JavaScript frameworks,such as- react js,node.js express.js Etc.</p>
                    </div>
                </div>
                <div className="row mt-4 p-2">
                    <div className="col-md-2">
                    <FaReact className="icons"/>
                    </div>
                    <div className="col-md-9">
                        <h5>React Js Development</h5>
                        <p>I have been consistantly working on a popular javascript framework called react js.Have clear Knowledge about Context API, Redux and hooks.</p>
                    </div>
                </div>
                <div className="row mt-4 p-2">
                    <div className="col-md-2">
                    <FaTv className="icons"/>
                    </div>
                    <div className="col-md-9">
                        <h5>Web Design</h5>
                        <p>Design makes the website charming. A perfect design in the prerequisite of any website. I use various css frameworks such as Bootstrap, Tailwind CSS, & Material UI for designing the website.</p>
                    </div>
                </div>
                <div className="row mt-4">
                    <div className="col-md-2">
                    <FaMicrophone className="icons"/>
                    </div>
                    <div className="col-md-9">
                        <h5>Voice Artist</h5>
                        <p>In burden to my passion I have been working as a Radio Jockey in one of my varsity Radio platform named <a className="text-success fw-bold" target="_blank" href="http://kuetradio.org/">KUET Radio.</a>So far the journey is amazing with this non-profit platform. </p>
                    </div>
                </div>
            </div>
            </div>
        </div>
    );
};

export default SpecialIn;